// extracted by mini-css-extract-plugin
module.exports = {"termsArea":"styles_termsArea__ivn7G","show":"styles_show__R0yej"};